import React from 'react';
import classNames from 'classnames';
import css from './EditUserMainInfoSection.css';
import HeartIcon from '../../icons/HeartIcon';
import { FormattedMessage } from '../../../../util/reactIntl';
import { Tooltip, AvailabilityBadge, FavoriteIcon } from '../../../../components';
import { ConditionalWrapper } from '../../../../util/common';
import { RIDER_AVAILABILITY_NOT_AVAILABLE } from '../../../../marketplace-custom-config';
import { isProfileComplete } from '../../../../util/user';

const RecommendAndCheckAvailabilityHolder = ({
    isSameUser,
    isPublic,
    inquiryDisabled,
    riderListing,
    currentUser,
    riderPage,
    firstName,
    user,
}) => {
    const { attributes } = user;
    const { profile } = attributes;
    const { publicData } = profile;
    const { availabilityStatus = RIDER_AVAILABILITY_NOT_AVAILABLE } = publicData;
    const { currentUserType } = currentUser.attributes.profile.publicData;

    const notAvailable = availabilityStatus === RIDER_AVAILABILITY_NOT_AVAILABLE;
    const isRider = currentUserType === 'rider';

    const noFavorite = inquiryDisabled || isSameUser || isRider || notAvailable;

    const { isPrimaryFieldsComplete } = isProfileComplete(user);

    const resolveActionDisabledKey = () => {
        const usersAreRiders = riderPage && isRider && 'usersAreRiders';
        const isSameUserKey = isSameUser && 'isSameUser';
        const notAvailableKey = notAvailable && RIDER_AVAILABILITY_NOT_AVAILABLE;

        return isSameUserKey || usersAreRiders || notAvailableKey || 'default';
    };

    const actionDisabledKey = resolveActionDisabledKey();

    return !riderPage ? null : (
        <aside
            className={classNames(css.recommendAndCheckAvailabilityHolder, {
                [css.recommendAndCheckAvailabilityHolderOwn]: !isPublic && isSameUser,
                [css.recommendAndCheckAvailabilityHolderPublic]:
                    isPublic && !isPrimaryFieldsComplete,
            })}
        >
            {isPublic && (
                <ConditionalWrapper
                    condition={noFavorite || !riderListing}
                    wrapper={children => (
                        <Tooltip
                            targetClassName={css.tooltipRecommendTarget}
                            tooltipClassName={classNames({
                                [css.tooltip]: true,
                                [css.recommendUserTooltip]: true,
                            })}
                            content={
                                <>
                                    <p>Hinzufügen nicht möglich</p>
                                    <p>
                                        <FormattedMessage
                                            id={`Favorites.action.disabled.desc.${actionDisabledKey}`}
                                            values={{ userName: firstName }}
                                        />
                                    </p>
                                </>
                            }
                        >
                            {children}
                        </Tooltip>
                    )}
                >
                    {noFavorite || !riderListing ? (
                        <HeartIcon
                            rootClassName={classNames([css.recommendUserIcon, css.inquiryDisabled])}
                        />
                    ) : (
                        <div className={css.favorite}>
                            <FavoriteIcon
                                rootClassName={css.favoriteIcon}
                                inWishlistClassName={css.favoriteIconinWishlist}
                                currentListing={riderListing}
                            />
                        </div>
                    )}
                </ConditionalWrapper>
            )}
            {riderPage && (
                <AvailabilityBadge
                    user={user}
                    editAllowed={!isPublic}
                    helpTextAllowed
                    isPublic={isPublic}
                    onLightBackground
                />
            )}
        </aside>
    );
};

export default RecommendAndCheckAvailabilityHolder;
